import React from 'react';
import { styled } from 'ps-gui';

import { getPhrase } from '../data/phrases';

export default class PasswordValidationStatus extends React.PureComponent {
	render() {
		const { validations, validationStatus } = this.props;
		return <PasswordValidations>
			{validations.map((validationId, index) => {
				const valid = validationStatus?.[validationId];
				return (
					<div className={'validation' + (valid ? ' valid' : '')} key={index}>
						<span className="icon">{valid ? '✓' : '•'}</span>
						<span className="text">{getPhrase('pwd.' + validationId)}</span>
					</div>
				);
			})}
		</PasswordValidations>;
	}
}

const PasswordValidations = styled.div`
	color: ${props => props.theme.disabledTextColor};
	font-size: 14px;
	line-height: 24px;
	font-weight: 400;
	margin-bottom: 24px;
	.validation {
		&.valid {
			font-weight: 700;
			.icon {
				color: #4FC098;
			}
		}
		.icon {
			display: inline-block;
			width: 32px;
			text-align: center;
		}
	}
`;
